import { chakra } from '@chakra-ui/react'

export const SocialButton = chakra('a', {
  baseStyle: {
    rounded: 'lg',
    w: '8',
    h: '8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgColor: 'blackAlpha.400',
    color: 'white',
    transition: 'all 0.2s',
    _hover: {
      bgColor: 'blackAlpha.500',
    },
  },
})
